import {
  Box,
  Typography,
  Button,
  Link,
  ThemeProvider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { generateTheme } from 'utils/helpers';

import { useStyles } from './account-tutorial-panel.styles';

export const AccountTutorialPanel = () => {
  const classes = useStyles();

  return (
    <ol>
      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Qué puedo hacer si olvidé mi contraseña para ingresar a Wellnub?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              1.- ¿Qué puedo hacer si olvidé mi contraseña para ingresar a
              Wellnub?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  EN COMPUTADORA: dirígete a la barra de navegación de Wellnub y
                  haz clic/toca en “Iniciar sesión”.
                  <br />
                  EN CELULAR: dirígete a la barra de navegación color gris y
                  toca el ícono con 3 rayas horizontales que se encuentra a la
                  derecha. Se desplegará un menú a la derecha de tu pantalla,
                  selecciona el botón “Iniciar sesión” que se encuentra en la
                  parte inferior del menú.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Haz clic/toca en el texto “¿Olvidaste tu contraseña?”.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Enseguida, ingresa el email con el que te diste de alta en
                  Wellnub (o el que le proporcionaste a tu nutriólogo en caso de
                  que él te haya dado de alta directamente) y haz clic/toca en
                  el botón “Enviar”.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Recibirás directo en tu email una contraseña provisional, la
                  cual usarás para poder iniciar sesión, ingresar a tu perfil y
                  establecer una nueva contraseña.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Cómo puedo cambiar mi contraseña?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              2.- ¿Cómo puedo cambiar mi contraseña?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Inicia sesión con la contraseña actual que tienes. Puede ser
                  una contraseña que tú mismo hayas establecido, el teléfono a
                  10 dígitos que le proporcionaste a tu nutriólogo para que te
                  agregara como su paciente, o bien, la contraseña provisional
                  que te envía Wellnub en caso de que hayas olvidado tu
                  contraseña.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  EN COMPUTADORA: en la barra de navegación wellnub.com dirígete
                  al ícono de persona que se encuentra del lado derecho,
                  presiónalo y selecciona “Configuración” y luego navega a la
                  sección{' '}
                  <Link
                    component={RouterLink}
                    to="/settings/profile"
                    underline="none"
                  >
                    <Typography
                      variant="h6"
                      component="span"
                      className={classes.asLink}
                    >
                      "Mi perfil"
                    </Typography>
                  </Link>{' '}
                  en el menú que se encuentra en el lado izquierdo.
                  <br />
                  EN CELULAR: dirígete a la barra de navegación color gris y
                  toca el ícono con 3 rayas horizontales que se encuentra a la
                  derecha. Se desplegará un menú a la derecha de tu pantalla,
                  selecciona el botón “Mi perfil” que se encuentra en la parte
                  inferior del menú.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Una vez que te encuentres dentro de la sección “Mi perfil”,
                  debajo de la subsección donde se encuentra tu información
                  personal, encontrarás los campos donde te pedimos ingresar tu
                  contraseña actual, así como los campos para seleccionar una
                  nueva contraseña y la confirmación de la nueva contraseña.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Cuando hayas completado los campos requeridos, simplemente haz
                  clic/toca en el botón “Actualizar contraseña” y ¡listo! Habrás
                  actualizado exitosamente tu contraseña.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Cómo puedo editar / actualizar mis datos personales?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              3.- ¿Cómo puedo editar / actualizar mis datos personales?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  EN COMPUTADORA: en la barra de navegación superior de
                  wellnub.com dirígete al ícono de persona que se encuentra del
                  lado derecho, presiónalo y selecciona “Configuración” y luego
                  navega a la sección{' '}
                  <Link
                    component={RouterLink}
                    to="/settings/profile"
                    underline="none"
                  >
                    <Typography
                      variant="h6"
                      component="span"
                      className={classes.asLink}
                    >
                      "Mi perfil"
                    </Typography>
                  </Link>{' '}
                  en el menú que se encuentra del lado izquierdo.
                  <br />
                  EN CELULAR: dirígete a la barra de navegación color gris y
                  toca el ícono con 3 rayas horizontales que se encuentra a la
                  derecha. Se desplegará un menú a la derecha de tu pantalla,
                  selecciona el botón “Mi perfil” que se encuentra en la parte
                  inferior del menú.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  En la sección “Mi Perfil” aparecerán los datos actuales que
                  tienes registrados en Wellnub. Actualiza los datos que deseas
                  editar.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Al terminar de editar tus datos, recuerda dar clic/toca en el
                  botón “Actualizar mi perfil” para guardar los cambios que
                  realizaste.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/*<Box mb={1} className={classes.wrapper}>*/}
      {/*  <Typography variant="h6">*/}
      {/*    ¿Cómo agrego/cambio mi forma de pago en Wellnub?*/}
      {/*  </Typography>*/}
      {/*  <Button variant="contained" size="small" color="primary">*/}
      {/*    Ver tutorial*/}
      {/*  </Button>*/}
      {/*</Box>*/}
      <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowForwardIosIcon />}
            colo="secondary"
          >
            <Typography variant="h6">
              4.- ¿Cómo agrego/cambio mi forma de pago en Wellnub?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol className={classes.innerList}>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  EN COMPUTADORA: en la barra de navegación superior de
                  wellnub.com dirígete al ícono de persona que se encuentra del
                  lado derecho, presiónalo y selecciona “Configuración”. De lado
                  izquierdo, verás un menú, selecciona{' '}
                  <Link
                    component={RouterLink}
                    to="/settings/payments"
                    underline="none"
                  >
                    <Typography
                      variant="h6"
                      component="span"
                      className={classes.asLink}
                    >
                      "Formas de pago"
                    </Typography>
                  </Link>
                  <br />
                  EN CELULAR: dirígete a la barra de navegación color gris y
                  toca el ícono con 3 rayas horizontales que se encuentra a la
                  derecha. Se desplegará un menú a la derecha de tu pantalla,
                  selecciona el botón “Formas de pago”” que se encuentra en la
                  parte inferior del menú.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  En la sección “Formas de pago”, haz clic/toca en el botón
                  “Agregar forma de pago +”.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Se desplegará una cortina del lado derecho de tu pantalla con
                  los campos para que introduzcas los datos de tu tarjeta.
                </Typography>
              </li>
              <li className={classes.innerListItem}>
                <Typography variant="body2">
                  Al finalizar, haz clic/toca en agregar tarjeta.
                </Typography>
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
    </ol>
  );
};
